/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Error_HomeInputs */

const en_auth_error_home = /** @type {(inputs: Auth_Error_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to the homepage`)
};

const es_auth_error_home = /** @type {(inputs: Auth_Error_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir a la página de inicio`)
};

/**
* | output |
* | --- |
* | "Go to the homepage" |
*
* @param {Auth_Error_HomeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_error_home = /** @type {((inputs?: Auth_Error_HomeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Error_HomeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_auth_error_home(inputs)
	return en_auth_error_home(inputs)
});